export default "assets/images/icons/white-arrow-beb8b212.svg";